import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useLogout from '../../../../hooks/useLogout';
import { DERegulatoryErrorCode, VerificationErrorCode } from '../../../../types/status';
import Prompt from '../../../Prompt/Prompt';

import {
  TXTSRV_Please_try_again_laterX,
  TXTWCL_Account_declined,
  TXTWCL_Okay,
  TXTWCL_SorryX_we_cannot_complete_your_ELL_1,
  TXTWCL_The_maximum_number_of_attempts_ELL,
  TXTWCL_We_canXt_complete_sign_up_beca_ELL_1
} from './SphonicVerificationError.messages.json';

interface Props {
  onClose(): void;
  code: string;
}

const SphonicVerificationError: React.FC<Props> = ({ onClose, code }) => {
  const logout = useLogout();

  const handleClose = () => {
    if (code === VerificationErrorCode.ElectronicVerificationFailedTooManyRequests) {
      logout();
    }
    onClose();
  };

  let bodyMessage;

  switch (code) {
    case VerificationErrorCode.ElectronicVerificationFailed:
      bodyMessage = (
        <Typography>
          <Translation {...TXTWCL_SorryX_we_cannot_complete_your_ELL_1} />{' '}
          <Translation {...TXTSRV_Please_try_again_laterX} />
        </Typography>
      );
      break;
    case DERegulatoryErrorCode.SERVICE_NOT_AVAILABLE:
      bodyMessage = (
        <Typography>
          <Translation {...TXTWCL_We_canXt_complete_sign_up_beca_ELL_1} />{' '}
          <Translation {...TXTSRV_Please_try_again_laterX} />
        </Typography>
      );
      break;
    case VerificationErrorCode.ElectronicVerificationFailedTooManyRequests:
      bodyMessage = (
        <Typography>
          <Translation {...TXTWCL_The_maximum_number_of_attempts_ELL} />{' '}
          <Translation {...TXTSRV_Please_try_again_laterX} />
        </Typography>
      );
      break;
  }

  return (
    <Prompt
      onClose={handleClose}
      variant="default"
      title={{ translation: TXTWCL_Account_declined }}
      onPrimaryButtonClick={handleClose}
      primaryButton={{ translation: TXTWCL_Okay }}
    >
      {bodyMessage}
    </Prompt>
  );
};

export default SphonicVerificationError;
